import type { DepositMethodId } from "@/features/wallet/components/deposit/types";

// PayID is not instant, so it is withheld from the Quick Deposit path in the
// betslip. A user without an instant method still gets the full method list.
export const BETSLIP_EXCLUDED_DEPOSIT_METHODS: readonly DepositMethodId[] = [
  "payid",
];
